module.exports = __webpack_public_path__ + "img/nabl_gallery6.d74d38e9.jpg";